



















































import { Component, Vue, Prop } from "vue-property-decorator";
import { ServiceArise, getUserAriseServices } from "../../../api/service-api";

@Component({})
export default class SalesReportSales extends Vue {
  @Prop({ required: true }) sales!: string;
  @Prop({ required: true }) purchaseAmounts!: string;
  @Prop({ required: true }) total!: string;
  @Prop({ required: true }) profit!: string;
  @Prop({ required: true }) totalProfit!: string;
  @Prop({ required: true }) profitability!: string;
  @Prop({ required: true }) totalProfitability!: string;
  @Prop({ required: true }) salesComparison!: string;
  @Prop({ required: true }) salesChange!: string;
  @Prop({ required: true }) salesChangeColor!: string;
  @Prop({ required: true }) invoices!: string;
  @Prop({ required: true }) purchases!: string;
  @Prop({ required: true }) purchasesTotal!: string;

  roles: ServiceArise[] = [];

  private async initServiceRoles() {
    this.roles = await getUserAriseServices();
  }

  get service() {
    return this.$store.state.service;
  }

  protected async created() {
    this.initServiceRoles();
  }
}
